import { render, staticRenderFns } from "./AuthorMonitor.vue?vue&type=template&id=63ff3026&scoped=true"
import script from "./AuthorMonitor.vue?vue&type=script&lang=js"
export * from "./AuthorMonitor.vue?vue&type=script&lang=js"
import style0 from "./AuthorMonitor.vue?vue&type=style&index=0&id=63ff3026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff3026",
  null
  
)

export default component.exports